import { useRef, useEffect } from "react";
import { config } from "../../Constants";
import { Autocomplete } from "@react-google-maps/api";
import { useIntl } from "react-intl";

const GoogleAutoComplete = ({
  onPlaceSelected,
  inputValue,
  setInputValue,
  isProfile,
}) => {
  const autoCompleteRef = useRef(null);
  const inputRef = useRef(null);
  const intl = useIntl();

  // Get user's location on mount
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        const { latitude, longitude } = position.coords;
        if (!isProfile || inputValue === "") {
          const address = await getAddressFromCoords(latitude, longitude);
          if (address) {
            setInputValue(address);
          }
        }
      });
    }
  }, []);

  const getAddressFromCoords = async (lat, lng) => {
    const apiKey = config.url.GOOGLE_API_KEY;
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;
    try {
      const response = await fetch(url);
      const data = await response.json();
      const address = data.results[0]?.formatted_address || "";
      sessionStorage.setItem("currentAddress", address);
      return address;
    } catch (error) {
      console.error("Geocoding error:", error);
      return "";
    }
  };

  const handleLoad = (autocomplete) => {
    autoCompleteRef.current = autocomplete;
  };

  const handlePlaceChanged = () => {
    const place = autoCompleteRef.current?.getPlace();
    if (place && place.formatted_address) {
      setInputValue(place.formatted_address);
      onPlaceSelected?.(place);
    }
  };

  return (
    <Autocomplete
      onLoad={handleLoad}
      onPlaceChanged={handlePlaceChanged}
      className="justify-items-center"
    >
      <input
        ref={inputRef}
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        className="row-Search form-control"
        placeholder={
          isProfile ? intl.formatMessage({ id: "EnterHomeAddress" }) : ""
        }
        id="AddressId"
      />
    </Autocomplete>
  );
};

export default GoogleAutoComplete;
